<div class="ra-progress-btn" [attr.data-progress]='step'>
    <svg width="100%" height="100%" viewBox="0 0 40 40">
        <circle class="ra-donut-hole" cx="20" cy="20" r="16"></circle>
        <circle class="ra-donut-ring" cx="20" cy="20" r="16"></circle>
        <circle class="ra-donut-segment" cx="20" cy="20" r="16" ></circle>
    </svg>
    <div class="ra-progress-btn-text"> <p>進度<span ></span>/4</p> </div>
</div>
